import React, { useState, useEffect } from "react"
import _ from 'lodash'
import { field_attrs } from "components/table/lib/column-field"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { NumberInput, DropdownInput, TextInput } from "components/table/carousel/inputs"

const Prop13Tax = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function, property: {}}) => {
  const emptyRecord = {
    year1AmtType: null,
    year1Amt: null,
    percent: null,
    valuationScenario: null,
    inflationNamedItemId: null,
  }
  const [data, setData] = useState<object|null>(props.rowData)
  const inflationOptions = _.map(
    _.get(props, "namedItems.inflation"),
    item => {
      return {value: item.inflationid, label: item.code}
    }
  )

  let inflationMappedCode = "*Departmental"
  const inflationDefault = _.get(_.find(inflationOptions, o => o.label === inflationMappedCode), "value")

  const valuationOptions = _.map(_.get(props, 'namedItems.valuationItems'), (v) => ({value: v.valuationPeriod, label: `#${v.valuationPeriod}: ${v.valuationDescription}`, default: v.defaultScenario}))
  const valuationDefault = _.get(_.find(valuationOptions, {default: true}), 'value')

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'prop13Tax') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val: number|string, field: string):void {
    let localCache = _.cloneDeep(data);
    let nextData = _.cloneDeep(props.rowData)

    // defaults
    _.set(nextData, "lineitemdetail.state", "prop13Tax")
    _.defaultsDeep(nextData, {lineitemdetail: {inflationNamedItemId: inflationDefault}})
    _.defaultsDeep(nextData, {lineitemdetail: {valuationScenario: valuationDefault}})
    _.defaultsDeep(nextData, {lineitemdetail: {year1AmtType: "Valuation Scenario"}})
    _.defaultsDeep(nextData, {lineitemdetail: {year1Amt: null}})

    // set value
    _.set(nextData, field, val)
    _.set(localCache, field.replace(/^.*\./,''), val)

    // conditionally null amt
    if(field === 'lineitemdetail.year1AmtType' && val === 'Valuation Scenario') {
      _.set(nextData, 'lineitemdetail.year1Amt', null)
      _.set(localCache, 'year1Amt', null)
    }

    setData(localCache)

    nextData["inputtype"] = "prop13Tax"
    nextData["amt"] = null
    nextData["amttype"] = null
    nextData["areaid"] = null
    nextData["inflationdetail"] = null

    delete nextData.lineitemdetail.revenue
    delete nextData.lineitemdetail.inflateFromAnalysisBegin

    props.persist(nextData, props.field, props.rowData)
  }

  const attrs = (field) => field_attrs('lineitem')(field)(props.rowData, props)
  const amtDisabled = _.includes([null, undefined, 'Valuation Scenario'], _.get(props, 'rowData.lineitemdetail.year1AmtType'))

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Year 1 Amt Type</label>
          <DropdownInput className="automated" data={data} attrs={attrs} default={"Valuation Scenario"}
            field="lineitemdetail.year1AmtType" options={['Valuation Scenario', 'Amount']} persist={updateData} />
        </div>
        <div className="narrow">
          <label>Amt</label>
          { amtDisabled
          ? <TextInput field={"dummy"} data={{dummy: "N/A"}} disabled/>
          : <NumberInput className="automated" data={data} attrs={attrs} field="lineitemdetail.year1Amt" readPrecision={0} writePrecision={0} persist={updateData} />
          }

        </div>
        <div className="narrow">
          <label>% of Value</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="lineitemdetail.percent" readPrecision={6} writePrecision={6} persist={updateData} />
        </div>
        <div>
          <label>Valuation Scenario</label>
          <DropdownInput className="automated" data={data} attrs={attrs} field="lineitemdetail.valuationScenario" options={valuationOptions} persist={updateData} default={valuationDefault} />
        </div>
        <div>
          <label>Inflation</label>
          <DropdownInput className="automated" data={data} attrs={attrs} field="lineitemdetail.inflationNamedItemId" options={inflationOptions} persist={updateData} default={inflationDefault} />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default Prop13Tax
